import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Dashboard.FinancialBalance;

export type FinancialBalanceHealthFamily = "green" | "amber" | "orange" | "red";

export type FinancialBalanceHealthTier = {
	minRatio: number;
	label: typeof R.healthGreat;
	family: FinancialBalanceHealthFamily;
};

const HEALTH_TIERS: FinancialBalanceHealthTier[] = [
	{ minRatio: 0.25, label: R.healthGreat, family: "green" },
	{ minRatio: 0.15, label: R.healthGood, family: "green" },
	{ minRatio: 0.05, label: R.healthTight, family: "amber" },
	{
		minRatio: Number.NEGATIVE_INFINITY,
		label: R.healthWarning,
		family: "orange",
	},
];

const NEGATIVE_HEALTH_TIER: FinancialBalanceHealthTier = {
	minRatio: Number.NEGATIVE_INFINITY,
	label: R.healthNegative,
	family: "red",
};

export const isPositiveFinancialBalance = (balance: number) => balance >= 0;

export const getFinancialBalanceRatio = (income: number, balance: number) => {
	if (income > 0) return balance / income;

	return isPositiveFinancialBalance(balance) ? 1 : -1;
};

export const getFinancialBalanceTier = (
	income: number,
	balance: number,
): FinancialBalanceHealthTier => {
	if (!isPositiveFinancialBalance(balance)) return NEGATIVE_HEALTH_TIER;

	const ratio = getFinancialBalanceRatio(income, balance);
	return HEALTH_TIERS.find((item) => ratio >= item.minRatio) ?? HEALTH_TIERS[0];
};
